// Generated by CoffeeScript 2.6.1
import getColor from "./getColor";

export default function() {  /*
    v.attrs.style = {}
    v.attrs.color = "red||blue||green||pink..."
  */
  return {
    data: {
      value: ""
    },
    oninit: function(v) {
      var ref;
      if (!v.state.data.value) {
        return v.state.data.value = (ref = v.attrs.value) != null ? ref : "";
      }
    },
    view: function(v) {
      var _this, ref;
      _this = this;
      return m((ref = v.attrs.tagName) != null ? ref : "", {
        class: v.attrs.class,
        style: {
          userSelect: v.attrs.isBtn ? "none" : void 0,
          "-webkit-user-select": v.attrs.isBtn ? "none" : void 0,
          display: v.attrs.isBlock ? "block" : "inline-block",
          margin: "0.5rem",
          padding: "1rem",
          background: getColor(v.attrs.color).back,
          color: getColor(v.attrs.color).front,
          border: v.attrs.hasBorder ? "0.1rem solid #ccc" : "none",
          cursor: v.attrs.isBtn ? "pointer" : void 0,
          textAlign: v.attrs.isBtn ? "center" : void 0,
          boxShadow: v.attrs.hasShadow ? "0 0 1rem rgba(0,0,0,0.05)" : void 0,
          //backdropFilter:"blur(10px)"
          //"-webkit-backdrop-filter":"blur(10px)"
          borderRadius: "3rem",
          //处理换行
          wordWrap: "break-all",
          overflowWrap: "anywhere",
          whiteSpace: "normal",
          transition: "opacity 0.5s ease",
          ...v.attrs.style,
          ...(v.attrs.isSwitch ? {
            display: "inline-flex",
            alignItems: "center",
            minWidth: "4rem",
            minHeight: "2rem",
            padding: "0",
            borderRadius: "20rem",
            position: "relative",
            verticalAlign: "middle",
            transition: "background 0.5s ease",
            cursor: "pointer",
            ...(!_this.data.value ? {
              background: "#e1e1e1"
            } : void 0)
          } : void 0)
        },
        /*
        (if v.attrs.isBtn 
          {
            onmouseover:(e,a)->
              @style.opacity = "0.8" if v.attrs.isBtn
              v.attrs.onmouseover? @,e,v,_this
              e.stopPropagation()
            onmouseout:(e)->
              @style.opacity = "1" if v.attrs.isBtn
              v.attrs.onmouseout? @,e,v,_this
              e.stopPropagation()
          }
        )...
        */
        onclick: function(e) {
          var base;
          if (v.attrs.disabled) {
            return;
          }
          if (v.attrs.isSwitch) {
            _this.data.value = !_this.data.value;
          }
          return typeof (base = v.attrs).onclick === "function" ? base.onclick(this, e, v, _this) : void 0;
        },
        onchange: function(e) {
          var base;
          if (v.attrs.disabled) {
            return;
          }
          return typeof (base = v.attrs).onchange === "function" ? base.onchange(this, e, v, _this) : void 0;
        },
        /*
        onfocus:(e)->
          e.stopPropagation()
          if e.target.tagName.match /input|textarea/ig
            e.target.scrollIntoView
              smooth:true
              block:"start"
            document.querySelector("#home").scrollTop -= 200
          v.attrs.onfocus? @,e,v,_this
        */

        // 表单型属性 必须被new才可使用
        oninput: function(e) {
          var base;
          if (v.attrs.disabled) {
            return;
          }
          if (((function() {
            switch (e.target.type) {
              case "text":
                return true;
              case "textarea":
                return true;
              case "password":
                return true;
              case "number":
                return true;
            }
          })())) {
            _this.data.value = e.target.value;
          }
          return typeof (base = v.attrs).oninput === "function" ? base.oninput(this, e, v, _this) : void 0;
        },
        ...(!v.attrs.noValue ? {
          value: this.data.value
        } : void 0),
        //contenteditable: v.attrs.contenteditable
        //placeholder:v.attrs.placeholder
        autocomplete: "off",
        ...v.attrs.ext
      }, [
        v.attrs.isSwitch ? m("",
        {
          style: {
            display: "inline-block",
            margin: "0.2rem",
            width: "1.6rem",
            height: "1.6rem",
            background: "white",
            borderRadius: "50%",
            transition: "all 0.5s ease",
            marginLeft: _this.data.value ? "58%" : "0.2rem"
          }
        }) : void 0,
        ...v.children
      ]);
    }
  };
};
